import type { FC } from 'react';

import type { IconProps } from './BaseIcon';
import { BaseIcon } from './BaseIcon';

export const PinIcon: FC<IconProps> = ({ ...props }) => (
  <BaseIcon viewBox="0 0 9 10" {...props}>
    <path d="M7.5 0C7.77614 0 8 0.223858 8 0.5C8 0.776142 7.77614 1 7.5 1H7.08984L8.0791 6.5H8.5C8.77614 6.5 9 6.72386 9 7C9 7.27614 8.77614 7.5 8.5 7.5H5V9.5C5 9.77614 4.77614 10 4.5 10C4.22386 10 4 9.77614 4 9.5V7.5H0.5C0.223858 7.5 0 7.27614 0 7C0 6.72386 0.223858 6.5 0.5 6.5H1.08984L2.0791 1H1.5C1.22386 1 1 0.776142 1 0.5C1 0.223858 1.22386 0 1.5 0H7.5ZM3.06592 1C3.07484 1.05455 3.07526 1.11144 3.06494 1.16895L2.10596 6.5H7.06348L6.10449 1.16895C6.09416 1.11142 6.09459 1.05457 6.10352 1H3.06592Z" />
  </BaseIcon>
);
